<template>
  <div>
    <v-container>
            <v-row justify-space-between>
              <v-col>
                <v-card class="pa-2 mr-2" flat min-height="340px" height="100%">
                  <Transactions />
                </v-card>
              </v-col>
            </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Transactions from "@/components/Transactions";

export default {
  components: {
    Transactions
  },
  computed: {
  },
  mounted() {
  },
  data: () => ({
    loading: false,
    settings: {},
  })
};
</script>

<style>
</style>